// auth-role.service.ts
export type UserRole = 'User' | 'Lawyer' | 'Unlogged' | 'Admin';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthRole {
  userRole: UserRole = 'Unlogged';
  userValidate: boolean | undefined;
  isReferral: boolean = false;

  constructor() {
    this.loadUserRole();
  }

  getUserRole(): UserRole {
    return this.userRole;
  }

  getUserValidate(): boolean {
    return !!this.userValidate;
  }

  getIsReferral(): boolean {
    return this.isReferral;
  }

  private loadUserRole(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      if (user && user.role) {
        if (
          user.role === 'User' ||
          user.role === 'Lawyer' ||
          user.role === 'Admin'
        ) {
          this.userRole = user.role;
          this.userValidate = user.emailConfirmed;
        } else {
          this.userRole = 'Unlogged';
        }
      }
      this.isReferral = user.referral_account === true;
    } else {
      this.userRole = 'Unlogged';
      this.isReferral = false;
    }
  }
}
